import { render, staticRenderFns } from "./ClientReferral.vue?vue&type=template&id=39d3a458&scoped=true&"
import script from "./ClientReferral.vue?vue&type=script&lang=js&"
export * from "./ClientReferral.vue?vue&type=script&lang=js&"
import style0 from "./ClientReferral.vue?vue&type=style&index=0&id=39d3a458&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d3a458",
  null
  
)

export default component.exports